import { render } from "./AddClaim.vue?vue&type=template&id=bc9e7ca8&ts=true"
import script from "./AddClaim.vue?vue&type=script&lang=ts"
export * from "./AddClaim.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__